import { BenefitContentListComponent } from './benefits/benefit-content-list/benefit-content-list.component';
import { BenefitPostComponent } from './benefits/benefit-post/benefit-post.component';
import { PitchBlogComponent } from './benefits/pitch-blog/pitch-blog.component';
import { CountryLevelSyllabusComponent } from './country-level-syllabus/country-level-syllabus.component';
import { ListingGroupComponent } from './groups/listing-group/listing-group.component';
import { ListingGroupingComponent } from './groups/listing-grouping/listing-grouping.component';

import { MathModule } from './../math/math.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { CountryFlagComponent } from './country-flag/country-flag.component';
import { CountryInfoComponent } from './country-info/country-info.component';
import { DreamComponent } from './landing/dream/dream.component';
import { FeatureTwoComponent } from './landing/feature-two/feature-two.component';
import { FeatureComponent } from './landing/feature/feature.component';
import { LandingComponent } from './landing/landing.component';

import { WeeklyPackageComponent } from './landing/level-info-two/weekly-package/weekly-package.component';
import { PitchFourComponent } from './landing/pitch-four/pitch-four.component';
import { PitchOneComponent } from './landing/pitch-one/pitch-one.component';
import { PitchThreeComponent } from './landing/pitch-three/pitch-three.component';
import { PitchTwoComponent } from './landing/pitch-two/pitch-two.component';
import { QuoteOneComponent } from './landing/quote-one/quote-one.component';
import { QuoteTwoComponent } from './landing/quote-two/quote-two.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ScoreSummaryComponent } from './score-summary/score-summary.component';
import { SyllabusInfoComponent } from './syllabus-info/syllabus-info.component';
import { TopicInfoComponent } from './syllabus-info/topic-info/topic-info.component';
import { SpinnerComponent } from './util/spinner/spinner.component';


import { SlideShowNiceComponent } from './landing/slide-show-nice/slide-show-nice.component';

import { DataTablesModule } from 'angular-datatables';
import { NgImageSliderModule } from 'ng-image-slider';
import { MarkdownModule } from 'ngx-markdown';
import { BenefitRelatedPostComponent } from './benefits/benefit-related-post/benefit-related-post.component';
import { CardHomeOptionComponent } from './cards/card-home-option/card-home-option.component';
import { ChooseCountryComponent } from './choose-country/choose-country.component';
import { CountryLevelSyllabusDetailComponent } from './country-level-syllabus-detail/country-level-syllabus-detail.component';
import { EmailFormComponent } from './email-form/email-form.component';
import { FreeAccessToPdfComponent } from './free-access-to-pdf/free-access-to-pdf.component';
import { FreeDownloadComponent } from './free-download/free-download.component';
import { GetItFromGooglePlayComponent } from './get-it-from-google-play/get-it-from-google-play.component';
import { CardGridComponent } from './landing/card-grid/card-grid.component';
import { GridDemoComponent } from './landing/grid-demo/grid-demo.component';
import { LevelInfoDisplayComponent } from './landing/level-info-display/level-info-display.component';
import { MathFunComponent } from './math-fun/math-fun.component';
import { NavHomeStudentComponent } from './nav-home-student/nav-home-student.component';

import { SideBarGuardianHomeComponent } from './side-bar-guardian-home/side-bar-guardian-home.component';
import { UserListFragmentComponent } from './user-list-fragment/user-list-fragment.component';
import { EmptyComponent } from './util/empty/empty.component';
import { ErrorComponent } from './util/error/error.component';
import { LoadingComponent } from './util/loading/loading.component';

@NgModule({
  declarations: [

    SpinnerComponent,
    DreamComponent,

    PitchOneComponent,
    PitchTwoComponent,
    PitchThreeComponent,
    PitchFourComponent,

    QuoteOneComponent,
    QuoteTwoComponent,
    FeatureComponent,
    FeatureTwoComponent,

    WeeklyPackageComponent,
    LandingComponent,
    SyllabusInfoComponent,
    TopicInfoComponent,
    NotFoundComponent,

    ScoreSummaryComponent,
    CountryInfoComponent,
    CountryFlagComponent,
    ComingSoonComponent,

    SlideShowNiceComponent,
    CardGridComponent,
    BenefitPostComponent,
    BenefitContentListComponent,
    FreeDownloadComponent,
    BenefitRelatedPostComponent,
    NavHomeStudentComponent,
    GridDemoComponent,
    PitchBlogComponent,
    ChooseCountryComponent,
    LevelInfoDisplayComponent,
    CardHomeOptionComponent,
    CountryLevelSyllabusComponent,
    CountryLevelSyllabusDetailComponent,
    LoadingComponent,
    EmptyComponent,
    GetItFromGooglePlayComponent,
    ListingGroupComponent,
    ListingGroupingComponent,
    EmailFormComponent,
    UserListFragmentComponent,
    ErrorComponent,
    MathFunComponent,
    FreeAccessToPdfComponent,
    SideBarGuardianHomeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MathModule,
    NgImageSliderModule,
    MarkdownModule,
    DataTablesModule

  ],
  exports: [
    SpinnerComponent,
    DreamComponent,
    ErrorComponent,
    PitchOneComponent,
    PitchTwoComponent,
    PitchThreeComponent,
    PitchFourComponent,

    QuoteOneComponent,
    QuoteTwoComponent,
    FeatureComponent,
    FeatureTwoComponent,

    WeeklyPackageComponent,
    LandingComponent,
    SyllabusInfoComponent,
    TopicInfoComponent,
    ScoreSummaryComponent,
    CountryInfoComponent,
    CountryFlagComponent,
    ComingSoonComponent,
    NavHomeStudentComponent,
    PitchBlogComponent,
    GridDemoComponent,
    ChooseCountryComponent,
    LevelInfoDisplayComponent,
    CardHomeOptionComponent,
    CountryLevelSyllabusComponent,
    LoadingComponent,
    EmptyComponent,
    GetItFromGooglePlayComponent,
    ListingGroupComponent,
    ListingGroupingComponent,
    EmailFormComponent,
    UserListFragmentComponent,
    MathFunComponent,
    FreeAccessToPdfComponent,
    SideBarGuardianHomeComponent

  ]
})
export class SharedModule { }
